import ActivityFrame from "@/components/activity-frame/activity-frame";
import { getErrorMessage } from "@/services/utilities/ServiceError.ts";
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogButton, DialogContent } from "../components/dialog/Dialog";
import { useDialog } from "../components/dialog/DialogContext";
import { LOGIN_STATUS } from "../constants/user-login-constants";
import { useLocale } from '../contexts/localeContext';
import { TranslationKeys } from '../contexts/TranslationKeys';
import brandLogo from '../images/brand_logo_color.png';
import footerLogoIcon from "../images/CompanyLogo.png";
import productLogo from '../images/product_logo_menu.svg';
import { ButtonTypes } from "../models/ButtonTypes";
import { useGlobalState } from "../Providers";
import { authLogin, getLoginById } from '../services/loginService';
import { IAppState } from '../store/types';
import { setUserInfoState } from '../store/user-info/actions';

const SsoContainer: FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { translate } = useLocale();
    const isAuthenticated = useSelector((state: IAppState) => (state.userInfo.isAuthenticated));
    const [busy, setBusy] = useState(false);
    const dialog = useDialog();
    const baseUrl = window.location.href;
    const { loadBuildInfo } = useGlobalState() ?? {};
    const location = useLocation();
    const initialValues = {
        remember: false,
        username: '',
        password: '',
        authCode: undefined,
        status: LOGIN_STATUS.OK
    };

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/')
        }
    }, [isAuthenticated])

    useEffect(() => {
        // Only run if not already authenticated
        handlePotentialLogin();
    }, []);

    const updateIsAuthenticated = (userLogin: any) => {
        dispatch(
            setUserInfoState({
                ...userLogin,
                isAuthenticated: true
            })
        );
    }

    const handlePotentialLogin = async () => {
        setBusy(true);
        try {
            const fields = {
                username: '',
                password: '',
                authCode: undefined,
            }
            const userDetails = await authLogin(fields, {}) as any;
            if (userDetails) {
                await handleLogin(userDetails);
            } else {
                const dialogContent: DialogContent = {
                    title: translate.byKey(TranslationKeys.error),
                    message: translate.byKey(TranslationKeys.failedToLogin),
                    buttons: getLoginErrorButtonOptions()
                }
                dialog.pushInfo(dialogContent);
            }
        } catch (error) {
            const dialogContent: DialogContent = {
                title: translate.byKey(TranslationKeys.error),
                message: getErrorMessage(error),
                buttons: getLoginErrorButtonOptions()
            }
            dialog.pushInfo(dialogContent);
        } finally {
            setBusy(false);
        }
    }

    const redirectPage = () => {
        const currentPath = location.pathname;
        window.location.assign(baseUrl.replace(currentPath, ""));
    }

    const getLoginErrorButtonOptions = (): DialogButton[] => {
        return [
            {
                id: "OK",
                text: translate.byKey(TranslationKeys.ok),
                onClick: () => redirectPage(),
                type: ButtonTypes.BlueRoundedButton
            }];
    }

    const handleLogin = async (userDetails) => {
        sessionStorage.setItem("token", JSON.stringify(userDetails.accessToken));
        const userLogin = await getLoginById(userDetails.userLoginId) as any;
        loadBuildInfo && loadBuildInfo();

        dispatch(
            setUserInfoState({
                ...userLogin,
                remember: false,
                isAuthenticated: false
            })
        );
        // No reason to stop the user from login.
        updateIsAuthenticated(userLogin);
    }

    return <div className='flex flex-col items-center p-2 justify-center'>
        <img src={brandLogo} style={{ width: '19rem' }} alt="" />
        <img src={productLogo} className="w-64 product-logo" alt="" />
        {/* <span className="text-xl pb-2">{translate.byKey(TranslationKeys.signIn)}</span> */}
        <div style={{ minWidth: '300px' }}>
            <ActivityFrame busy={busy} busyMessage={translate.byKey(TranslationKeys.signIn)} />
            {/* Company logo */}
            <div className="footer-logo">
                <img src={footerLogoIcon} alt="impro logo" className="h-auto mt-1 pl-12 max-w-full w-64" />
            </div>

        </div>
    </div>
};

export default SsoContainer;
